var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 3,
    fill: "#30BAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9731 7.25186C17.7435 7.12425 17.491 7.04312 17.2301 7.0131C16.9691 6.98308 16.7048 7.00477 16.4522 7.07693C16.1996 7.14908 15.9637 7.27029 15.758 7.43362C15.5522 7.59696 15.3807 7.79922 15.2531 8.02886L11.5401 14.7109L9.41514 12.5859C9.23064 12.3948 9.00996 12.2425 8.76595 12.1377C8.52194 12.0328 8.2595 11.9777 7.99394 11.9754C7.72838 11.9731 7.46502 12.0237 7.21923 12.1242C6.97344 12.2248 6.75013 12.3733 6.56235 12.5611C6.37456 12.7489 6.22606 12.9722 6.1255 13.218C6.02493 13.4637 5.97433 13.7271 5.97664 13.9927C5.97895 14.2582 6.03412 14.5207 6.13894 14.7647C6.24375 15.0087 6.39612 15.2294 6.58714 15.4139L10.5871 19.4139C10.9651 19.7929 11.4751 20.0009 12.0011 20.0009L12.2781 19.9809C12.5847 19.938 12.8771 19.8245 13.1324 19.6494C13.3876 19.4744 13.5987 19.2424 13.7491 18.9719L18.7491 9.97186C18.8768 9.74231 18.958 9.48987 18.9881 9.22894C19.0182 8.96801 18.9966 8.70372 18.9245 8.45114C18.8524 8.19856 18.7313 7.96265 18.5681 7.75688C18.4049 7.5511 18.2027 7.3795 17.9731 7.25186Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskIcon);
export default __webpack_public_path__ + "static/media/Task_Icon.585efe70802d24465adc1e2400e69c01.svg";
export { ForwardRef as ReactComponent };